module.exports = __webpack_public_path__ + "img/1543463007.6855f009.jpg";